export * from "./cars-terms.component";
